import AdminLists from './adminLists.vue'

export default AdminLists




// WEBPACK FOOTER //
// ./src/views/user/adminLists/index.js